<template>
    <div>
        <b-modal id="modalChargeForm" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
			<div class="fullscreen" v-if="show">
				<div class="head">
					<div class="container">
                        <div class="btn icon icon-close invert" @click="close"></div>
						<h1>{{title}}</h1>
					</div>
				</div>
				<div class="content bg-grey">
					<div class="container">
						
                        <b-form-group label="Descripción" class="mt-4">
                            <b-form-input
                                v-model="form.description"
                                placeholder="Ingrese una descripción"
                                :state="!validation.hasError('form.description')" 
                            ></b-form-input>                            
                            <b-form-invalid-feedback>Ingrese una descripción</b-form-invalid-feedback>
                        </b-form-group>
                        
                        <b-form-group label="Costo" class="mt-4">
                            
                            <div class="input-group" style="width:190px;">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">U$S</span>
                                </div>
                                <vue-numeric 
                                    separator="," 
                                    v-model="form.price" 
                                    class="form-control text-right" 
                                    :precision="2" ></vue-numeric>
                            </div>
                            <b-form-invalid-feedback>Ingrese una price</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group label="Archivos adjuntos" class="mt-4">
                            <UploadMultiple
                                v-model="form.files" 
                                :placeholder="'Adjuntar archivo'"
                                :invalid="validation.hasError('form.images')" 
                            ></UploadMultiple>
                        </b-form-group>

					</div>
				</div>
				<div class="footer">
					<div class="container">
						<div class="btn btn-block btn-primary" @click="save()">
							Continuar
						</div>
					</div>
				</div>

			</div>
		</b-modal>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import mixins from '@/mixins/mixins'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

import UploadMultiple from '@/components/UploadMultiple'

export default {
    name: "ChangeForm",
    components:{
		UploadMultiple
    },
    mixins:[mixins],
    props:{
        value:{
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            show: false,
            saving: false,
            title: null,
            form: {
				key: null,
				description:null,
				price: 0,
				files: [],
			},
        }
    },
    computed: {
		...mapState(['control']),
	},
    validators: {
		'form.description': function (value) {
			return Validator.value(value).required();
		},
		'form.price': function (value) {
			return Validator.value(value).required();
		},
		// 'form.files': function (value) {
		// 	return Validator.custom( () => {
		// 		if(value.length<=0){ return true}
		// 		return false
		// 	})
		// },
	},
    methods:{
        ...mapMutations(['saveControl']),
        open () {
            this.title = 'Crear cargo'
            this.form = {
                key: null,
				description:null,
				price: 0,
				files: [],
            }
            this.show = true
			this.$bvModal.show('modalChargeForm')
        },
        update (charge) {
            this.title = 'Editar daño'
			this.form = charge
            this.show = true
			this.$bvModal.show('modalChargeForm')
		},
		close () {
			this.$bvModal.hide('modalChargeForm')
		},
        async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				if(!this.form.key){
					this.form.key = this.control.charges.length+1
					this.control.charges.push(this.form)
                }
				this.saveControl(this.control)
				this.saving = false
				this.close()
			}
		}
    }

}
</script>

<style lang="scss" scoped>
.list-item{
    margin:4px 0px;
    display: flex;

     > div:first-child{
        flex-grow: 1;
    }
}
</style>